import {
  Route, Redirect, BrowserRouter as Router
} from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Container, Grid } from '@mui/material';
import theme from "./styles/Theme";
import Form from './page';
import './App.css';

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
          <Form />
      </ThemeProvider>
    </div>
  );
}

export default App;
